import { create } from 'zustand';

export interface AuthUser {
  id: string;
  email: string;
  name: string;
  orgId: string;
  isSuperUser: boolean;
}

interface AuthState {
  user: AuthUser | null;
  accessToken: string | null;
  isAuthenticated: boolean;
  // Called from the login route handler after POST /auth/login succeeds.
  login(token: string, user: AuthUser): void;
  // Called from the axios refresh interceptor after a silent token refresh.
  setAccessToken(token: string): void;
  setUser(user: AuthUser | null): void;
  // Called on POST /auth/logout success OR when refresh fails. Clears in-memory
  // state — the httpOnly refresh cookie is cleared by the backend response.
  logout(): void;
}

// Per spec §1.7: accessToken lives in memory only, never localStorage. On
// page reload the bootstrap calls POST /auth/refresh — if the httpOnly cookie
// is still valid, a new accessToken is minted and the store rehydrates.
export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  accessToken: null,
  isAuthenticated: false,
  login: (token, user) => set({ accessToken: token, user, isAuthenticated: true }),
  setAccessToken: (token) => set({ accessToken: token, isAuthenticated: true }),
  setUser: (user) => set({ user }),
  logout: () => set({ accessToken: null, user: null, isAuthenticated: false }),
}));
